<template>
  <div id="app">
    <HeadMenu @keyChange="keyChange"/>
    <router-view/>
    <Contact/>
    <TopTap/>
  </div>
</template>

<script>
import HeadMenu from '@/components/header/HeadMenu'
import TopTap from '@/components/footer/TopTap'
import Contact from '@/components/footer/Contact'

export default {
  components: {
    HeadMenu,
    Contact,
    TopTap
  },
  methods: {
    keyChange (key) {
      this.$router.push(key)
    }
  }
}
</script>

<style>
body {
  margin: 0;
  padding: 0;
}
</style>
